import React, {useEffect, useMemo, useState} from "react";
import {connect} from 'react-redux'
import Form from 'components/Form';
import {withRouter} from "react-router";
import {DemandValidation, DemandValidationKeys} from 'constants/DemandValidation';
import ValidationShema from "constants/ValidationShema";
import Loading from "components/Loading";
import ResultNoticeService from "services/ResultNoticeService";
import AttachmentResultNotice from "./components/AttachmentResultNotice";
import OjsResultNotice from "./components/OjsResultNotice";
import ResultNoticeType from "./constants/ResultNoticeType";
import DemandValidationMessages from "components/DemandValidationMessages";
import makeStyles from "@material-ui/core/styles/makeStyles";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import Tr from "translations/Translations";
import {isNationalProcedure} from "libs/getDemandStatus";
import AddBzpResultNoticePopup from "components/complex/documentsTables/swz/AddBzpResultNoticePopup";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    }
}))

function ResultNoticePanel(
    {
        match,
        demandValidation,
        resultNotice,
        demandHeader
    }) {

    const classes = useStyles();
    const demandId = match.params.id;

    const currentDemandValidation = DemandValidation.RESULT_NOTICE;
    const section = demandValidation.find(x => x.section === currentDemandValidation);
    const editable = section ? section.editable : true;
    const ojsAdmin = section ? section.ojsAdmin : false;
    const bzpEditable = section ? !!section.bzpEditable : false;
    // eslint-disable-next-line
    const nationalProcedure = useMemo(() => isNationalProcedure(), [demandHeader]);
    const [addBzpNoticePopupOpened, setAddBzpNoticePopupOpened] = useState(false);

    useEffect(() => {
        ResultNoticeService.getResultNotice(demandId);
        return () => {
            ResultNoticeService.clearResultNoticeResources();
        }
    }, [demandId])

    const getButtons = () => {
        const buttons = [];
        if (nationalProcedure && bzpEditable) {
            buttons.push(createButton(Tr("add_bzp_result_notice"), () => setAddBzpNoticePopupOpened(true)))
        }

        if (buttons.length)
            return <MultiButton buttons={buttons} justify="flex-start"/>
    }

    if (!resultNotice) return <Loading/>

    return (
        <Form
            initialValues={{}}
            validationSchema={ValidationShema.any()}
            id={DemandValidationKeys.RESULT_NOTICE}
        >{(formikProps) =>
            (<div className={classes.root}>
                {getButtons()}

                <DemandValidationMessages editable={editable} section={section}/>
                {resultNotice.type === ResultNoticeType.ATTACHMENT &&
                <AttachmentResultNotice editable={editable} demandId={demandId} resultNotice={resultNotice}/>}
                {resultNotice.type === ResultNoticeType.OJS  &&
                    <OjsResultNotice
                        demandId={demandId}
                        editable={editable}
                        ojsAdmin={ojsAdmin}
                        resultNotice={resultNotice}
                        canPublishOjsResultNotice={!!section && section.canPublishOjsResultNotice}
                        ojsResultNoticeSend={!!section && section.ojsResultNoticeSend}
                    />}

                {addBzpNoticePopupOpened && <AddBzpResultNoticePopup demandId={demandId} onClose={() => setAddBzpNoticePopupOpened(false)}/>}
            </div>)}
        </Form>
    )
}


export default connect((state) => ({
    resultNotice: state.resources[ResultNoticeService.RESULT_NOTICE_RESOURCE_ID],
    demandValidation: state.resources.demandValidation,
    demandHeader: state.resources.demandHeader
}), {})(withRouter(ResultNoticePanel));